var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 2.66675C23.3734 2.66675 29.3334 8.62675 29.3334 16.0001C29.3334 23.3734 23.3734 29.3334 16.0001 29.3334C8.62675 29.3334 2.66675 23.3734 2.66675 16.0001C2.66675 8.62675 8.62675 2.66675 16.0001 2.66675ZM22.6667 9.33341H19.3334L18.0001 8.00008H14.0001L12.6667 9.33341H9.33341V12.0001H22.6667V9.33341ZM12.0001 24.0001H20.0001C20.3537 24.0001 20.6928 23.8596 20.9429 23.6096C21.1929 23.3595 21.3334 23.0204 21.3334 22.6667V13.3334H10.6667V22.6667C10.6667 23.0204 10.8072 23.3595 11.0573 23.6096C11.3073 23.8596 11.6465 24.0001 12.0001 24.0001Z",
    fill: "#C1BCBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFilter);
export default __webpack_public_path__ + "static/media/delete-filter.56cccadc72b6aaa9514f8c3c3e5753f6.svg";
export { ForwardRef as ReactComponent };